import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import BienesManager from "./BienesManager";

const BienesForm = ({ procesoId }) => {
  const [showNewBienModal, setShowNewBienModal] = useState(false);

  return (
    <Box>
      <BienesManager
        procesoId={procesoId}
        showNewBienModal={showNewBienModal}
        setShowNewBienModal={setShowNewBienModal}
      />
    </Box>
  );
};

BienesForm.propTypes = {
  procesoId: PropTypes.number.isRequired,
};

export default BienesForm;
